const { replace } = require('lodash');

class GiftCardItemController {
    constructor($filter, $timeout, settings, moveFocus) {
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.settings = settings;
        this.moveFocus = moveFocus;

        if (!this.onChangeGiftCardAmount) {
            this.onChangeGiftCardAmount = () => {};
        }
    }

    $onInit() {
        const instrumentId = this.card.PaymentInstrumentId || this.card.NewStagedCardId;
        this.giftCardDetailsId = `giftCardDetails${instrumentId}`;
        this.giftCardAmountId = `giftCardAmount${instrumentId}`;
        this.giftCardSuffix = this.card.CardSuffix || this.getCardSuffixFromCardNumber(this.card.CardNumber);
    }

    getCardSuffixFromCardNumber(cardNumber) {
        return cardNumber && cardNumber.length === this.settings.digitalPay.giftCardNumberLength
            ? cardNumber.slice(-4)
            : '';
    }

    getExpiryYear(expiryYear) {
        // Truncate 4 digit years to 2
        return expiryYear && expiryYear.length === 4
            ? expiryYear.slice(-2)
            : expiryYear;
    }

    getGiftCardAmount(amount) {
        return amount ? parseFloat(amount) : 0.0;
    }

    isProblemCard() {
        return !this.card.IsCondensed && (!this.card.Balance || this.card.Expired);
    }

    isCardUnavailable() {
        return this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardKnownBalanceCheckFailed ||
            this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardUnknownBalanceCheckFailed ||
            this.card.ErrorCode === this.settings.digitalPayErrorCodes.giftCardBalanceApiUnavailable;
    }

    toggleSelectCard() {
        this.errorMessage = '';
        if (this.onSelect && !this.manageMode) {
            this.onSelect(this.card);

            // Move the focus to the amount field
            this.$timeout(() => {
                if (this.card.Selected) {
                    this.moveFocus(`#${this.giftCardAmountId}`);
                }
            });
        }
    }

    onChangeAmount() {
        const amount = this.getGiftCardAmount(this.card.Amount);

        this.errorMessage = amount > parseFloat(this.card.Balance) && !this.isCardUnavailable()
            ? replace(this.settings.digitalPayError.giftCardAmountAvailableExceedMessage, '{AMOUNTAVAILABLE}', this.$filter('currency')(this.card.Balance))
            : '';

        this.onChangeGiftCardAmount({ amount, card: this.card });
    }
}

GiftCardItemController.$inject = ['$filter', '$timeout', 'Settings', 'MoveFocus'];

const giftCardItemComponentDefinition = {
    controller: GiftCardItemController,
    template: require('./gift-card-item.component.html').trim(),
    transclude: true,
    bindings: {
        card: '<',
        allowedBins: '<',
        manageMode: '<',
        onSelect: '&?',
        onRemove: '&?',
        onChangeGiftCardAmount: '&',
        isInline: '<',
        showDisabled: '<',
    },
};

module.exports = {
    GiftCardItemController,
    giftCardItemComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/giftcard/gift-card-item.component.js